import defaultTable from '@/components/layout/defaultTable/DefaultTable.vue'
import { mapState, mapActions } from 'vuex'
import constants from '@/util/constants'
import util from '@/util'

export default {
  name: 'estagiario',
  components: {
    'default-table': defaultTable
  },

  computed: {
    ...mapState('usuarios', ['listaCoordenadoresDisponiveis', 'listaCapasDisponiveis', 'dadosPerfil', 'dadosRetorno', 'flagsDeControle'])
  },

  data: () => {
    return {
      timeOutDigitacaoNocombo: null,
      comboCoordenadoresDisponiveis: [],

      comboCapasDisponiveis: [],
      capaSelecionada: null,
      fieldsCapa: [
        { key: 'f_name', sortable: false, label: 'Nome' },
        { key: 'opcoes', sortable: false, label: 'Opções' }
      ],
      codigoDaOpcaoTodosNoComboDeCapas: 0
    }
  },

  mounted () {
    this.limparListaErros()
    this.obterCoordenadoresDisponiveis()
    this.obterCapasDisponiveis()
  },

  methods: {
    ...mapActions('usuarios', ['ActionDefinirListaCoordenadores', 'ActionDefinirListaCapas']),

    tabelaSemRegistros (item, type) {
      if (util.valorVazio(item) && type === 'row-empty') {
        return 'text-center'
      }
    },

    eventoDigitarBuscaPorCoordenador (valorDigitadoParaBusca, callbackFlagCarregamento) {
      clearTimeout(this.timeOutDigitacaoNocombo)
      let referenciaObjetoDaView = this

      this.timeOutDigitacaoNocombo = setTimeout(function () {
        referenciaObjetoDaView.obterCoordenadoresDisponiveis(valorDigitadoParaBusca, callbackFlagCarregamento)
      }, constants.tempoParaAguardarDigitacaoNoCombo)
    },

    async obterCoordenadoresDisponiveis (valorDigitadoParaBusca, callbackFlagCarregamento) {
      if (!util.valorEhNulo(callbackFlagCarregamento)) {
        callbackFlagCarregamento = true
      }

      let parametrosRequisicao = {
        'registrosPorPagina': constants.defaultRegistrosCombo,
        'filtros': { 'f_name': valorDigitadoParaBusca }
      }
      await this.ActionDefinirListaCoordenadores(parametrosRequisicao)
      this.comboCoordenadoresDisponiveis = this.listaCoordenadoresDisponiveis.map(function (registro) {
        return { label: registro.user.f_name, code: registro.f_id }
      })
      callbackFlagCarregamento = false
    },

    eventoDigitarBuscaPorCapa (valorDigitadoParaBusca, callbackFlagCarregamento) {
      this.limparListaErros()

      clearTimeout(this.timeOutDigitacaoNocombo)
      let referenciaObjetoDaView = this

      this.timeOutDigitacaoNocombo = setTimeout(function () {
        referenciaObjetoDaView.obterCapasDisponiveis(valorDigitadoParaBusca, callbackFlagCarregamento)
      }, constants.tempoParaAguardarDigitacaoNoCombo)
    },

    async obterCapasDisponiveis (valorDigitadoParaBusca, callbackFlagCarregamento) {
      if (!util.valorEhNulo(callbackFlagCarregamento)) {
        callbackFlagCarregamento = true
      }
      let parametrosRequisicao = {
        'registrosPorPagina': constants.defaultRegistrosCombo,
        'filtros': { 'f_name': valorDigitadoParaBusca }
      }

      await this.ActionDefinirListaCapas(parametrosRequisicao)
      this.comboCapasDisponiveis = this.listaCapasDisponiveis.map(function (registro) {
        return { label: registro.user.f_name, code: registro.user.f_id }
      })
      if (!util.valorVazio(this.comboCapasDisponiveis)) {
        this.comboCapasDisponiveis.unshift({ label: 'Todos', code: 0 })
      }
      callbackFlagCarregamento = false
    },

    adicionarNaListagemDeCapas () {
      this.limparListaErros()

      if (util.valorEhNulo(this.capaSelecionada)) {
        this.dadosRetorno.listaDeErros['f_profile_data.f_capas'] = 'Selecione uma capa'
        this.resetarCamposDeCapas()
      } else {
        const temCapa = this.dadosPerfil.f_capas.some((capa) => capa.f_view === this.capaSelecionada.code)
        if (temCapa) {
          this.dadosRetorno.listaDeErros['f_profile_data.f_capas'] = 'Esta capa já foi adicionada'
        } else {
          this.adicionarCapasNaLista()
        }
      }
      this.resetarCamposDeCapas()
    },

    adicionarCapasNaLista () {
      if (this.capaSelecionada.code === this.codigoDaOpcaoTodosNoComboDeCapas) {
        this.adicionarTodasAsCapas()
      } else {
        this.adicionarUmaCapa(this.capaSelecionada)
      }
    },

    adicionarTodasAsCapas () {
      const listaDeTodasAsCapas = this.comboCapasDisponiveis
      for (const indice in listaDeTodasAsCapas) {
        const capa = listaDeTodasAsCapas[indice]
        const temCapa = this.dadosPerfil.f_capas.some((capaDaLista) => capaDaLista.f_view === capa.code)
        const naoEhcodigoTodasCapas = capa.code !== this.codigoDaOpcaoTodosNoComboDeCapas
        if (!temCapa && naoEhcodigoTodasCapas) {
          this.adicionarUmaCapa(capa)
        }
      }
    },

    adicionarUmaCapa (capa) {
      const obj = {
        'f_view': capa.code,
        'f_name': capa.label
      }
      this.dadosPerfil.f_capas.push(obj)
    },

    excluirDaListagemDeCapas (item) {
      const indice = this.dadosPerfil.f_capas.map(
        function (elemento) {
          return elemento.f_view
        }).indexOf(item.f_view)
      if (indice !== -1) {
        this.dadosPerfil.f_capas.splice(indice, 1)
      }
    },

    resetarCamposDeCapas () {
      this.capaSelecionada = null
    },

    limparListaErros () {
      this.dadosRetorno.listaDeErros = {}
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    }
  }
}
